// AccountDialogs.jsx
import AccountCreateDialog from "./accountCreateDialog";
import AccountEditDialog from "./accountEditDialog";

export default function AccountDialogs({ openDialog, data, closeDialog, onSubmit, onDelete, onDeleteRequest, onShowSuccess, experience }) {
  
  switch (openDialog) {
    case "create":
      return <AccountCreateDialog onClose={closeDialog} onSubmit={onSubmit} onShowSuccess={onShowSuccess} />;
    case "edit":
      return (
        <AccountEditDialog
          data={data}
          onClose={closeDialog}
          onSubmit={onSubmit}
          onDelete={onDelete}
          onDeleteRequest={onDeleteRequest}
          onShowSuccess={onShowSuccess}
          experience={experience}
        />
      );
    default:
      return null;
  }
}
